export const dcrControlStyles = {
	button: {
		textTransform: 'none',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		minWidth: 'max-content',
		height: '32px',
		fontWeight: 700,
		lineHeight: 1
	}
};
